import { AUTH_SERVICE } from "@/datas/authservice";

export default Object.freeze({
  display: (value) => {
    return value === "T" ? "진열" : "진열안함";
  },
  selling: (value) => {
    return value === "T" ? "판매중" : "판매안함";
  },
  certStatus: (value) => {
    if (value === "inactivated") {
      return "미인증";
    } else if (value === "activated") {
      return "인증완료";
    } else if (value === "lost") {
      return "분실";
    } else {
      return "-";
    }
  },
  defaultString: (value) => {
    return !value ? "-" : value;
  },
  defaultDate: (value) => {
    if (!value) {
      return "-";
    } else {
      let date = value.split(" ");
      return `${date[0]}</br>${date[1]}`;
    }
  },
  numberFormat: (value) => {
    if (!value) {
      return value;
    } else {
      value += "";
      var whole, fraction;
      let decIndex = value.lastIndexOf(".");
      if (decIndex > 0) {
        whole = value.substr(0, decIndex);
        fraction = value.substr(decIndex);
      } else {
        whole = value;
      }
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(whole)) {
        whole = whole.replace(rgx, "$1" + "," + "$2");
      }
      return fraction ? whole + fraction : whole;
    }
  },
  excelErrorMessages: (data) => {
    return data.toString().replace(",", "</br>");
  },
  validatedAndExpiredAt: (data) => {
    if (data.cert_validated_at && data.cert_expired_at) {
      let validatedAt = data.cert_validated_at.substr(0, 10);
      let expiredAt = data.cert_expired_at.substr(0, 10);
      return `${validatedAt}</br>~${expiredAt}`;
    } else {
      return "-";
    }
  },
  warrantyPeriod: (data) => {
    let items = {
      d: "일",
      m: "개월",
      y: "년",
    };
    if (
      data.cert_validated_at !== null &&
      data.cert_validated_at !== undefined
    ) {
      let validatedAt = data.cert_validated_at.substr(0, 10);
      let expiredAt = data.cert_expired_at.substr(0, 10);
      return `${validatedAt}</br>~${expiredAt}`;
    } else {
      let count = data.cert_duration.replace(/[a-z]/gi, "");
      let type = data.cert_duration.replace(/[0-9]/g, "");
      let text =
        data.cert_duration_type === AUTH_SERVICE.ACTIVATED
          ? "인증일로부터"
          : "생성일로부터";
      return `${text}</br>${count}${items[type]}`;
    }
  },
});
